(function () {
  var root = document.getElementById("kalkylator-custom");
  if (!root) return;
  var data =
    window.__KALKYLATOR_DATA__ && window.__KALKYLATOR_DATA__.custom || null;
  if (!data || !data.collections) return;

  /* \u2500\u2500 State \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var state = {
    step: 1,
    rooms: [{ name: "Rum 1", length: "", width: "" }],
    totalArea: 0,
    totalPerimeter: 0,
    frisEnabled: false,
    frisSize: "68x204",
    lopbandEnabled: false,
    lopbandSize: "68x204",
    selectedType: null,
    selectedVariant: null,
    spillPct: 12
  };

  /* Blocks saveState() during init sequence */
  var initialized = false;

  /* \u2500\u2500 DOM refs \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var stepTabs = root.querySelectorAll(".stepTab"),
    panes = root.querySelectorAll(".stepPane"),
    roomsList = root.querySelector("#roomsList"),
    addRoomBtn = root.querySelector("#addRoomBtn"),
    clearRoomsBtn = root.querySelector("#clearRoomsBtn"),
    totalAreaLabel = root.querySelector("#totalAreaLabel"),
    nextToStep2 = root.querySelector("#nextToStep2"),
    backToStep1 = root.querySelector("#backToStep1"),
    nextToStep3 = root.querySelector("#nextToStep3"),
    backToStep2 = root.querySelector("#backToStep2"),
    doneBtn = root.querySelector("#doneBtn"),
    sortCards = root.querySelectorAll(".sortCard"),
    sizesAll = root.querySelector("#sizesAll"),
    /* Summary */
    sumProduct = root.querySelector("#sumProduct"),
    sumSize = root.querySelector("#sumSize"),
    sumPrice = root.querySelector("#sumPrice"),
    sumM2PerPack = root.querySelector("#sumM2PerPack"),
    sumFloorArea = root.querySelector("#sumFloorArea"),
    sumFrisRow = root.querySelector("#sumFrisRow"),
    sumFrisLabel = root.querySelector("#sumFrisLabel"),
    sumFrisArea = root.querySelector("#sumFrisArea"),
    sumTotalAreaRow = root.querySelector("#sumTotalAreaRow"),
    sumCombinedArea = root.querySelector("#sumCombinedArea"),
    sumNeed = root.querySelector("#sumNeed"),
    sumPacks = root.querySelector("#sumPacks"),
    sumDelivered = root.querySelector("#sumDelivered"),
    sumTotal = root.querySelector("#sumTotal"),
    addToCartBtn = root.querySelector("#addToCartBtn"),
    /* Fris */
    frisCheckbox = root.querySelector("#frisCheckbox"),
    frisOptions = root.querySelector("#frisOptions"),
    frisSizeBtns = root.querySelectorAll("[data-fris-size]"),
    frisPerimeterLabel = root.querySelector("#frisPerimeter"),
    frisAreaLabel = root.querySelector("#frisAreaLabel"),
    /* Cart & spill */
    spillSelect = root.querySelector("#spillSelect"),
    refreshCartBtn = root.querySelector("#refreshCartBtn"),
    cartItems = root.querySelector("#cartItems"),
    cartSubtotal = root.querySelector("#cartSubtotal");

  /* \u2500\u2500 Helpers \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var fmt2 = function (n) {
    return (Math.round(n * 100) / 100).toFixed(2).replace(".", ",");
  };
  var fmtMoney = function (cents) {
    var kr = Number(cents || 0) / 100;
    return (
      new Intl.NumberFormat("sv-SE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(kr) + " kr"
    );
  };
  var fmtMoneyPerM2 = function (cents) {
    var kr = Number(cents || 0) / 100;
    return (
      new Intl.NumberFormat("sv-SE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(kr) + " kr / m\u00b2"
    );
  };

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  /* Fris planks install perpendicular to wall: strip depth = plank LENGTH (parts[1]).
     e.g. "68x204" -> 204mm depth into the room. */
  function getFrisDepthMM() {
    var parts = String(state.frisSize || "68x204").split("x");
    return parseInt(parts[1], 10) || 204;
  }

  function parseDims(title) {
    var parts = String(title || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/\u00d7/g, "x")
      .split("x")
      .map(function (x) { return parseInt(x, 10); })
      .filter(function (n) { return !isNaN(n); });
    if (parts.length >= 3)
      return { t: parts[0] || 16, w: parts[1] || 0, l: parts[2] || 0 };
    if (parts.length === 2)
      return { t: 16, w: parts[0] || 0, l: parts[1] || 0 };
    return { t: 16, w: 0, l: 0 };
  }

  function getVariantsForType(type) {
    var col = data.collections[type];
    if (!col) return [];
    return (col.variants || [])
      .filter(function (v) { return Number(v.variant_id); })
      .map(function (v) {
        var d = parseDims(v.variant_title || v.product_title || ""),
          width = Number(v.width_mm || 0) || d.w || 0,
          length = Number(v.length_mm || 0) || d.l || 0,
          t = d.t || 16;
        var m2pp = Number(v.m2_per_pack || 0);
        if (!m2pp && window.__BOX_M2_BY_SIZE__) {
          var sizeKey = t + "x" + width + "x" + length;
          m2pp = window.__BOX_M2_BY_SIZE__[sizeKey] || 0;
        }
        return {
          product_id: v.product_id,
          product_title: v.product_title,
          product_handle: v.product_handle,
          image: v.image,
          variant_id: Number(v.variant_id || 0),
          variant_title: v.variant_title,
          available: v.available !== false,
          price_cents: Number(v.price_cents || 0),
          thickness_mm: t,
          width_mm: width,
          length_mm: length,
          m2_per_pack: m2pp
        };
      });
  }

  /* \u2500\u2500 CSS injection \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function injectStyles() {
    var s = document.createElement("style");
    s.textContent = [
      /* 1. Price per m\u00b2 on size cards \u2014 column layout so price sits cleanly below the plank */
      ".nw-plankbtn{flex-direction:column!important;align-items:center!important;justify-content:flex-start!important;padding-bottom:8px!important}",
      ".nw-plank-price{display:block;font-size:11px;color:#888;margin-top:8px;text-align:center;line-height:1.3;white-space:nowrap;width:100%}",
      ".nw-plankbtn.is-active .nw-plank-price{color:#333;font-weight:600}",
      /* Hide lim rec (not in stock yet) */
      "#limRec{display:none!important}",
      /* 4. KLAR green flash */
      ".klarBtn--done{background:#2d7a3a!important;color:#fff!important;border-color:#2d7a3a!important;transition:background .25s,border-color .25s,color .25s}",
      /* 7. Fris price breakdown */
      "#sumFrisCompare{display:none;font-size:12px;color:#888;text-align:right;margin-top:-2px;padding-bottom:6px}",
      "#sumFrisCompare.is-visible{display:block}",
      /* 10. Mobile sticky bar */
      ".kalk-mbar{display:none;position:fixed;bottom:0;left:0;right:75px;z-index:9999;background:#fff;border-top:1px solid #e0dbd5;padding:10px 20px calc(10px + env(safe-area-inset-bottom));box-shadow:0 -2px 14px rgba(0,0,0,.1);gap:14px;align-items:center}",
      ".kalk-mbar.is-visible{display:flex}",
      ".kalk-mbar.result-shown{display:none!important}",
      "@media(min-width:900px){.kalk-mbar{display:none!important}}",
      ".kalk-mbar__info{flex:1;min-width:0}",
      ".kalk-mbar__label{font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#999;margin-bottom:1px}",
      ".kalk-mbar__total{font-size:17px;font-weight:700;color:#1a1a1a;white-space:nowrap}",
      ".kalk-mbar__packs{font-size:11px;color:#888;white-space:nowrap;margin-right:4px}",
      ".kalk-mbar__btn{flex-shrink:0;padding:11px 18px;background:#1a1a1a;color:#fff;border:none;border-radius:3px;font-size:13px;font-weight:600;letter-spacing:.05em;cursor:pointer;white-space:nowrap}",
      ".kalk-mbar__btn:disabled{opacity:.35;cursor:default}",
      "#kalkylator-custom{padding-bottom:72px;overflow:clip!important}",
      "#shopify-chat{display:none!important}",
      ".kcard--right{align-self:start!important}",
      /* L\u00f6pband section */
      "#lopbandSection{margin-top:12px;background:rgb(245,245,247);border-radius:12px;padding:16px}",
      ".lopbandOptions{display:none;padding:12px 0 4px}",
      ".lopbandOptions.is-visible{display:block}",
      ".lopbandOptions__label{font-size:11px;text-transform:uppercase;letter-spacing:.06em;color:#999;margin-bottom:8px}",
      ".lopbandSizes{display:flex;flex-wrap:wrap;gap:12px;margin-bottom:14px}",
      "#frisSizes{display:flex;flex-wrap:wrap;gap:12px}",
      ".accessory-hint{font-size:12px;color:#aaa;line-height:1.55;margin:0 0 12px;font-style:italic}",
      /* Room visualizer */
      "#roomVizSection{margin:14px 0 6px}",
      ".roomViz__label{font-size:11px;text-transform:uppercase;letter-spacing:.06em;color:#999;margin-bottom:10px;text-align:center}",
      ".roomViz__legend{display:flex;gap:16px;margin-top:10px;flex-wrap:wrap;justify-content:center}",
      ".roomViz__swatch{display:inline-flex;align-items:center;gap:5px;font-size:12px;color:#666}",
      ".roomViz__dot{display:inline-block;width:12px;height:12px;border-radius:2px;flex-shrink:0}",
      /* Right card extras */
      ".kalk-klarna{display:block;margin:8px 0 12px}",
      ".kalk-provbit-btn{display:block;width:100%;text-align:center;padding:13px 24px;border:1px solid #1d1d1f;border-radius:980px;font-size:13px;font-weight:600;letter-spacing:1.04px;color:#1d1d1f;text-decoration:none;cursor:pointer;box-sizing:border-box;margin-bottom:8px;text-transform:uppercase;white-space:nowrap}",
      ".kalk-provbit-btn:hover{background:#faf6f1;border-color:#a0845c}",
      ".kalk-advisor-cta{display:block;text-align:center;font-size:12px;color:#999;text-decoration:none;padding:2px 0 14px;line-height:1.5}",
      ".kalk-advisor-cta:hover{color:#1a1a1a}",
      /* Tier price inside sort cards */
      ".sortCard--visual{display:flex!important;flex-direction:column!important}",
      ".sortCard--visual .sortCard__body{flex:1!important}",
      ".sortCard[data-type='select']{border-top:3px solid #1d1d1f!important}",
      ".sortCard__priceRow{text-align:center;border-top:1.5px solid #ebe7e2;padding:12px 16px 14px;border-radius:0 0 14px 14px}",
      ".sortCard[data-type='select'] .sortCard__priceRow{background:rgba(200,151,42,.07);border-top-color:#e8d5b0}",
      ".sortCard__badge{display:inline-block;background:#1d1d1f;color:#fff;font-size:9px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:2px 8px;border-radius:20px;margin-bottom:7px}",
      ".sortCard__badge--ghost{visibility:hidden;display:inline-block;font-size:9px;padding:2px 8px;margin-bottom:7px}",
      ".sortCard__total{display:block;font-size:16px;font-weight:700;color:#1a1a1a;letter-spacing:-.01em}",
      ".sortCard__total-from{font-size:10px;font-weight:400;color:#aaa;letter-spacing:0;text-transform:uppercase;margin-right:2px}",
      ".sortCard__ppm2{font-size:11px;color:#aaa;margin-top:3px}",
      /* Step 3: size prompt + popular tag + mobile plank fix */
      ".kalk-size-hint{font-size:13px;color:#bbb;text-align:center;padding:8px 0 18px;letter-spacing:.01em}",
      ".kalk-size-hint.is-hidden{display:none!important}",
      ".kalk-pop-tag{font-size:9px;font-weight:700;color:#1d1d1f;text-transform:uppercase;letter-spacing:.06em;margin-left:6px;vertical-align:middle}",
      /* Mobile: size picker becomes a horizontal swipe strip (owns its own wrapper) */
      ".nw-swipe-row{display:flex;flex-direction:row;overflow-x:auto;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;scrollbar-width:none;gap:0;padding:0 0 10px}",
      ".nw-swipe-row::-webkit-scrollbar{display:none}",
      ".nw-swipe-row>.nw-group{flex-shrink:0;padding:0 20px 4px 4px;border-right:1px solid #f0ece6;scroll-snap-align:start}",
      ".nw-swipe-row>.nw-group:last-child{border-right:none;padding-right:4px}",
      "@media(max-width:899px){.nw-plank{max-width:46px!important;max-height:100px!important;min-height:unset!important}.nw-group-bars{flex-wrap:nowrap!important;gap:8px!important}}"
    ].join("");
    document.head.appendChild(s);
  }

  /* \u2500\u2500 State persistence \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function saveState() {
    if (!initialized) return;
    try {
      sessionStorage.setItem("kalkylator_state_v2", JSON.stringify({
        rooms: state.rooms,
        selectedType: state.selectedType,
        selectedVariantId: state.selectedVariant ? state.selectedVariant.variant_id : null,
        frisSize: state.frisSize,
        lopbandSize: state.lopbandSize,
        spillPct: state.spillPct,
        step: state.step
      }));
    } catch (e) { /* noop */ }
  }

  function loadState() {
    try {
      var raw = sessionStorage.getItem("kalkylator_state_v2");
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (saved.rooms && saved.rooms.length > 0) {
        state.rooms = saved.rooms;
      }
      if (saved.spillPct != null && !isNaN(Number(saved.spillPct))) {
        state.spillPct = Number(saved.spillPct);
      }
      if (saved.frisSize) {
        /* Backwards compat: old format was just length "204", new format is "68x204" */
        var fs = String(saved.frisSize);
        state.frisSize = fs.indexOf("x") === -1 ? "68x" + fs : fs;
      }
      /* lopbandEnabled and frisEnabled intentionally not restored \u2014 always start collapsed */
      if (saved.lopbandSize) state.lopbandSize = saved.lopbandSize;
      if (saved.selectedType) {
        selectType(saved.selectedType);
      }
      if (saved.selectedVariantId) {
        state.__savedVariantId = saved.selectedVariantId;
      }
      if (saved.step) {
        state.__savedStep = saved.step;
      }
    } catch (e) { /* noop */ }
  }

  /* \u2500\u2500 Step navigation \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function setStep(step) {
    state.step = step;
    saveState();
    var canStep2 = state.totalArea > 0,
      canStep3 = canStep2 && !!state.selectedType;
    stepTabs.forEach(function (btn) {
      var s = Number(btn.dataset.step);
      btn.classList.toggle("is-active", s === step);
      btn.setAttribute("aria-selected", s === step ? "true" : "false");
      if (s === 1) btn.disabled = false;
      if (s === 2) btn.disabled = !canStep2;
      if (s === 3) btn.disabled = !canStep3;
    });
    panes.forEach(function (p) {
      p.classList.toggle("is-active", Number(p.dataset.pane) === step);
    });
    nextToStep2.disabled = !(state.totalArea > 0);
    nextToStep3.disabled = !state.selectedType;
    if (step === 2) {
      renderTierComparison();
    }
    if (step === 3) {
      renderSizes();
      renderFrisSizes();
      renderLopbandSizes();
      updateFrisDisplay();
      updateLopbandDisplay();
      updateSummary();
      setupStickyResult();
      setupRightCardExtras();
    }
    if (
      window.matchMedia &&
      window.matchMedia("(max-width: 900px)").matches
    ) {
      var leftCard = root.querySelector(".kcard--left");
      if (leftCard) leftCard.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  /* \u2500\u2500 Room rendering \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function renderRooms() {
    roomsList.innerHTML = "";
    state.rooms.forEach(function (r, idx) {
      var l = parseFloat(String(r.length || "").replace(",", ".").trim());
      var w = parseFloat(String(r.width || "").replace(",", ".").trim());
      var area = (!isNaN(l) && l > 0 && !isNaN(w) && w > 0) ? l * w : 0;
      var row = document.createElement("div");
      row.className = "roomRow";
      row.innerHTML =
        '<input class="inp" type="text" placeholder="t.ex. Vardagsrum" value="' + escapeHtml(r.name) + '" data-room-name="' + idx + '" />' +
        '<input class="inp" type="text" inputmode="decimal" placeholder="t.ex. 5,2" value="' + escapeHtml(String(r.length || "")) + '" data-room-length="' + idx + '" />' +
        '<input class="inp" type="text" inputmode="decimal" placeholder="t.ex. 3,4" value="' + escapeHtml(String(r.width || "")) + '" data-room-width="' + idx + '" />' +
        '<div class="roomRow__area">' + (area > 0 ? fmt2(area) + " m\u00b2" : "\u2014") + '</div>' +
        '<button type="button" class="iconBtn" aria-label="Ta bort rum" data-room-del="' + idx + '">\u00d7</button>';
      roomsList.appendChild(row);
    });
  }

  function recalcTotalArea() {
    var sumArea = 0;
    var sumPerimeter = 0;
    state.rooms.forEach(function (r) {
      var l = parseFloat(String(r.length || "").replace(",", ".").trim());
      var w = parseFloat(String(r.width || "").replace(",", ".").trim());
      if (!isNaN(l) && l > 0 && !isNaN(w) && w > 0) {
        sumArea += l * w;
        sumPerimeter += 2 * (l + w);
      }
    });
    state.totalArea = sumArea;
    state.totalPerimeter = sumPerimeter;
    totalAreaLabel.textContent = fmt2(sumArea);
    nextToStep2.disabled = !(sumArea > 0);
    updateFrisDisplay();
    updateLopbandDisplay();
    updateSummary();
    renderTierComparison();
    saveState();
  }

  function wireRoomInputs() {
    roomsList.addEventListener("input", function (e) {
      var t = e.target;
      if (t.matches("[data-room-name]")) {
        var idx = Number(t.dataset.roomName);
        state.rooms[idx].name = t.value;
        saveState();
      }
      if (t.matches("[data-room-length]")) {
        var idx2 = Number(t.dataset.roomLength);
        state.rooms[idx2].length = t.value;
        recalcTotalArea();
        renderRoomAreas();
      }
      if (t.matches("[data-room-width]")) {
        var idx3 = Number(t.dataset.roomWidth);
        state.rooms[idx3].width = t.value;
        recalcTotalArea();
        renderRoomAreas();
      }
    });
    roomsList.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-room-del]");
      if (!btn) return;
      var idx = Number(btn.dataset.roomDel);
      state.rooms.splice(idx, 1);
      if (state.rooms.length === 0) {
        state.rooms.push({ name: "Rum 1", length: "", width: "" });
      }
      renderRooms();
      recalcTotalArea();
    });
  }

  /* Re-render only the calculated area cells (avoid losing input focus) */
  function renderRoomAreas() {
    var areaCells = roomsList.querySelectorAll(".roomRow__area");
    state.rooms.forEach(function (r, idx) {
      if (!areaCells[idx]) return;
      var l = parseFloat(String(r.length || "").replace(",", ".").trim());
      var w = parseFloat(String(r.width || "").replace(",", ".").trim());
      var area = (!isNaN(l) && l > 0 && !isNaN(w) && w > 0) ? l * w : 0;
      areaCells[idx].textContent = area > 0 ? fmt2(area) + " m\u00b2" : "\u2014";
    });
  }

  /* \u2500\u2500 Fris \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function updateFrisDisplay() {
    var perim = state.totalPerimeter;
    var depth = getFrisDepthMM();
    var frisArea = perim * (depth / 1000);
    frisPerimeterLabel.textContent = fmt2(perim) + " m";
    frisAreaLabel.textContent = fmt2(frisArea) + " m\u00b2 (" + depth + " mm djup)";
  }

  function wireFris() {
    frisCheckbox.addEventListener("change", function () {
      state.frisEnabled = frisCheckbox.checked;
      frisOptions.classList.toggle("is-visible", state.frisEnabled);
      updateFrisDisplay();
      updateSummary();
      saveState();
    });
    /* Size button listeners are wired in renderFrisSizes() */
  }

  /* \u2500\u2500 Render accessory size buttons \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function renderAccessorySizes(containerId, currentSizeKey, onSelect) {
    var container = root.querySelector("#" + containerId);
    if (!container) return;
    var type = state.selectedType || "select";
    var variants = getVariantsForType(type)
      .filter(function (v) {
        return v.available && Number(v.width_mm) > 0 && Number(v.length_mm) > 0;
      })
      .sort(function (a, b) {
        if (Number(a.width_mm) !== Number(b.width_mm)) return Number(b.width_mm) - Number(a.width_mm);
        return Number(a.length_mm) - Number(b.length_mm);
      });
    container.innerHTML = "";
    if (!variants.length) return;

    var ws = variants.map(function (v) { return Number(v.width_mm); });
    var ls = variants.map(function (v) { return Number(v.length_mm); });
    var maxW = Math.max.apply(null, ws);
    var maxL = Math.max.apply(null, ls);
    var MAX_H = 120, MIN_H = 38, MAX_W = 50, MIN_W = 16;
    function sc(val, maxVal, lo, hi) {
      if (!val || !maxVal) return lo;
      return lo + (hi - lo) * (val / maxVal);
    }

    var groups = new Map();
    variants.forEach(function (v) {
      var w = String(Number(v.width_mm));
      if (!groups.has(w)) groups.set(w, []);
      groups.get(w).push(v);
    });

    groups.forEach(function (items, w) {
      var group = document.createElement("div");
      group.className = "nw-group";
      var lbl = document.createElement("div");
      lbl.className = "nw-group-label";
      lbl.textContent = w + " mm";
      group.appendChild(lbl);
      var bars = document.createElement("div");
      bars.className = "nw-group-bars";
      items.forEach(function (v) {
        var key = v.width_mm + "x" + v.length_mm;
        var pW = sc(Number(v.width_mm), maxW, MIN_W, MAX_W);
        var pH = sc(Number(v.length_mm), maxL, MIN_H, MAX_H);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "nw-plankbtn" + (currentSizeKey === key ? " is-active" : "");
        btn.dataset.sizeKey = key;
        btn.innerHTML =
          '<div class="nw-plank" style="--plank-w:' + pW.toFixed(0) + 'px;--plank-h:' + pH.toFixed(0) + 'px" aria-hidden="true">' +
          '<span>' + v.width_mm + '\u00d7' + v.length_mm + '</span></div>';
        btn.addEventListener("click", function () {
          onSelect(key);
          container.querySelectorAll(".nw-plankbtn").forEach(function (b) {
            b.classList.toggle("is-active", b.dataset.sizeKey === key);
          });
          updateFrisDisplay();
          updateSummary();
          saveState();
        });
        bars.appendChild(btn);
      });
      group.appendChild(bars);
      container.appendChild(group);
    });
  }

  function renderFrisSizes() {
    renderAccessorySizes("frisSizes", state.frisSize, function (key) {
      state.frisSize = key;
    });
  }

  function addFrisHint() {
    var label = root.querySelector(".frisOptions__label");
    if (!label || root.querySelector(".frisOptions .accessory-hint")) return;
    var hint = document.createElement("p");
    hint.className = "accessory-hint";
    hint.textContent =
      "V\u00e4lj samma bredd som ditt golv (68 mm eller 50 mm) f\u00f6r b\u00e4st passform. " +
      "Kortare l\u00e4ngd (204 mm) ger en diskret kant, l\u00e4ngre stavar (340\u2013408 mm) ger ett mer markant m\u00f6nster.";
    label.insertAdjacentElement("afterend", hint);
  }

  /* \u2500\u2500 L\u00f6pband section (dynamically injected) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var lopbandCheckboxEl = null, lopbandOptionsEl = null,
    lopbandAreaRowEl = null, lopbandAreaLabelEl = null, lopbandPerimeterLabelEl = null,
    vizSectionEl = null;

  function createLopbandSection() {
    if (root.querySelector("#lopbandSection")) return; /* already exists */
    var frisContainer = root.querySelector(".kalkylator__fris");
    if (!frisContainer || !frisContainer.parentElement) return;

    var sec = document.createElement("div");
    sec.id = "lopbandSection";
    sec.innerHTML =
      '<div class="frisToggle">' +
        '<label class="frisToggle__check">' +
          '<input type="checkbox" id="lopbandCheckbox">' +
          ' L\u00e4gg till l\u00f6pband (dekorativt band)' +
        '</label>' +
      '</div>' +
      '<div class="lopbandOptions" id="lopbandOptions">' +
        '<div class="lopbandOptions__label">V\u00e4lj storlek</div>' +
        '<p class="accessory-hint">V\u00e4lj valfri storlek \u2014 vanligast \u00e4r samma som golvet f\u00f6r ett s\u00f6ml\u00f6st uttryck. ' +
        'Bredare stavar ger ett tydligare band, smalare ett mer diskret. ' +
        'L\u00f6pbandet ber\u00e4knas automatiskt utifr\u00e5n rummets omkrets.</p>' +
        '<div class="lopbandSizes" id="lopbandSizes"></div>' +
        '<div class="frisInfo" id="lopbandAreaRow">' +
          '<div class="frisInfo__row">' +
            '<span>L\u00f6pmeter (omkrets)</span>' +
            '<span id="lopbandPerimeterLabel">\u2014</span>' +
          '</div>' +
          '<div class="frisInfo__row">' +
            '<span>Extra yta f\u00f6r l\u00f6pband</span>' +
            '<span id="lopbandAreaLabel">\u2014</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    /* Insert between .kalkylator__fris and .stepNav */
    var stepNav = frisContainer.parentElement.querySelector(".stepNav");
    if (stepNav) {
      frisContainer.parentElement.insertBefore(sec, stepNav);
    } else {
      frisContainer.parentElement.insertBefore(sec, frisContainer.nextSibling);
    }

    lopbandCheckboxEl = sec.querySelector("#lopbandCheckbox");
    lopbandOptionsEl = sec.querySelector("#lopbandOptions");
    lopbandAreaRowEl = sec.querySelector("#lopbandAreaRow");
    lopbandAreaLabelEl = sec.querySelector("#lopbandAreaLabel");
    lopbandPerimeterLabelEl = sec.querySelector("#lopbandPerimeterLabel");

    /* Restore state */
    if (state.lopbandEnabled) {
      lopbandCheckboxEl.checked = true;
      lopbandOptionsEl.classList.add("is-visible");
    }
  }

  function renderLopbandSizes() {
    renderAccessorySizes("lopbandSizes", state.lopbandSize, function (key) {
      state.lopbandSize = key;
    });
  }

  function updateLopbandDisplay() {
    if (!lopbandAreaLabelEl) return;
    var perim = state.totalPerimeter || 0;
    if (lopbandPerimeterLabelEl) {
      lopbandPerimeterLabelEl.textContent = perim > 0 ? fmt2(perim) + " lm" : "\u2014";
    }
    if (state.lopbandEnabled && perim > 0) {
      var lopW = parseInt(String(state.lopbandSize || "68x204").split("x")[0], 10) || 68;
      var lopArea = perim * (lopW / 1000);
      lopbandAreaLabelEl.textContent = fmt2(lopArea) + " m\u00b2 (" + lopW + " mm djup)";
    } else {
      lopbandAreaLabelEl.textContent = "\u2014";
    }
  }

  function wireLopband() {
    if (!lopbandCheckboxEl) return;
    lopbandCheckboxEl.addEventListener("change", function () {
      state.lopbandEnabled = lopbandCheckboxEl.checked;
      lopbandOptionsEl.classList.toggle("is-visible", state.lopbandEnabled);
      updateLopbandDisplay();
      updateSummary();
      saveState();
    });
  }

  /* \u2500\u2500 Room visualizer \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function createRoomVisualizer() {
    if (root.querySelector("#roomVizSection")) return;
    var lopSec = root.querySelector("#lopbandSection");
    if (!lopSec) return;

    var sec = document.createElement("div");
    sec.id = "roomVizSection";
    sec.style.display = "none";
    sec.innerHTML =
      '<div class="roomViz__label">Golvlayout \u2013 f\u00f6rhandsgranskning</div>' +
      '<svg id="roomVizSvg" viewBox="0 0 320 200" width="100%"' +
        ' style="max-width:420px;display:block;border-radius:6px;margin:0 auto" aria-hidden="true">' +
        /* Herringbone tile pattern: 28x28 = 2x2 blocks of 14x14 each.
           H-block = 2 landscape planks stacked; V-block = 2 portrait planks side-by-side.
           Checkerboard of H/V blocks creates the classic parquet herringbone. */
        '<defs>' +
          '<pattern id="rvHBPat" x="0" y="0" width="28" height="28" patternUnits="userSpaceOnUse">' +
            /* H-block (0,0): 2 horizontal planks */
            '<rect x="0"  y="0"  width="14" height="7"  fill="#e8e3dc" stroke="#c3bdb6" stroke-width="0.5"/>' +
            '<rect x="0"  y="7"  width="14" height="7"  fill="#e8e3dc" stroke="#c3bdb6" stroke-width="0.5"/>' +
            /* V-block (14,0): 2 vertical planks */
            '<rect x="14" y="0"  width="7"  height="14" fill="#f0ece7" stroke="#c3bdb6" stroke-width="0.5"/>' +
            '<rect x="21" y="0"  width="7"  height="14" fill="#f0ece7" stroke="#c3bdb6" stroke-width="0.5"/>' +
            /* V-block (0,14): 2 vertical planks */
            '<rect x="0"  y="14" width="7"  height="14" fill="#f0ece7" stroke="#c3bdb6" stroke-width="0.5"/>' +
            '<rect x="7"  y="14" width="7"  height="14" fill="#f0ece7" stroke="#c3bdb6" stroke-width="0.5"/>' +
            /* H-block (14,14): 2 horizontal planks */
            '<rect x="14" y="14" width="14" height="7"  fill="#e8e3dc" stroke="#c3bdb6" stroke-width="0.5"/>' +
            '<rect x="14" y="21" width="14" height="7"  fill="#e8e3dc" stroke="#c3bdb6" stroke-width="0.5"/>' +
          '</pattern>' +
        '</defs>' +
        /* Wall background */
        '<rect x="0" y="0" width="320" height="200" fill="#e8e5e1"/>' +
        /* Floor base */
        '<rect id="rvFloor" x="10" y="10" width="300" height="180" fill="#fafaf9"/>' +
        /* Herringbone center \u2014 resized dynamically to inner area */
        '<rect id="rvCenterFill" x="10" y="10" width="300" height="180" fill="url(#rvHBPat)"/>' +
        /* Fris \u2014 4 sides */
        '<rect id="rvFrisTop"    x="10" y="10"  width="300" height="7" fill="#1a1a1a" opacity="0"/>' +
        '<g    id="rvFrisTJ"/>' +
        '<rect id="rvFrisBottom" x="10" y="183" width="300" height="7" fill="#1a1a1a" opacity="0"/>' +
        '<g    id="rvFrisBJ"/>' +
        '<rect id="rvFrisLeft"   x="10" y="10"  width="7" height="180" fill="#1a1a1a" opacity="0"/>' +
        '<g    id="rvFrisLJ"/>' +
        '<rect id="rvFrisRight"  x="303" y="10" width="7" height="180" fill="#1a1a1a" opacity="0"/>' +
        '<g    id="rvFrisRJ"/>' +
        /* L\u00f6pband \u2014 4 sides, just inside fris */
        '<rect id="rvLopTop"    x="17" y="17"  width="286" height="6" fill="#7a7068" opacity="0"/>' +
        '<g    id="rvLopTJ"/>' +
        '<rect id="rvLopBottom" x="17" y="177" width="286" height="6" fill="#7a7068" opacity="0"/>' +
        '<g    id="rvLopBJ"/>' +
        '<rect id="rvLopLeft"   x="17" y="23"  width="6" height="154" fill="#7a7068" opacity="0"/>' +
        '<g    id="rvLopLJ"/>' +
        '<rect id="rvLopRight"  x="297" y="23" width="6" height="154" fill="#7a7068" opacity="0"/>' +
        '<g    id="rvLopRJ"/>' +
      '</svg>' +
      '<div class="roomViz__legend">' +
        '<span class="roomViz__swatch">' +
          '<span class="roomViz__dot" style="background:#e8e3dc;border:1px solid #c3bdb6"></span>Fiskben' +
        '</span>' +
        '<span class="roomViz__swatch" id="rvLegendFris" style="display:none">' +
          '<span class="roomViz__dot" style="background:#1a1a1a"></span>Fris' +
        '</span>' +
        '<span class="roomViz__swatch" id="rvLegendLop" style="display:none">' +
          '<span class="roomViz__dot" style="background:#7a7068"></span>L\u00f6pband' +
        '</span>' +
      '</div>';

    var next = lopSec.nextSibling;
    if (next) {
      lopSec.parentElement.insertBefore(sec, next);
    } else {
      lopSec.parentElement.appendChild(sec);
    }
    vizSectionEl = sec;
  }

  function updateRoomVisualizer() {
    var sec = vizSectionEl || root.querySelector("#roomVizSection");
    if (!sec) return;
    var show = state.frisEnabled || state.lopbandEnabled;
    sec.style.display = show ? "" : "none";
    if (!show) return;

    var FLOOR_X = 10, FLOOR_Y = 10, FLOOR_W = 300, FLOOR_H = 180;
    var NS = "http://www.w3.org/2000/svg";

    var frisParts = String(state.frisSize    || "68x204").split("x");
    var frisW = parseInt(frisParts[0], 10) || 68;
    var frisL = parseInt(frisParts[1], 10) || 204;
    var lopParts = String(state.lopbandSize || "68x204").split("x");
    var lopW  = parseInt(lopParts[0],  10) || 68;
    var lopL  = parseInt(lopParts[1],  10) || 204;

    /* FRIS: planks point INWARD from wall (perpendicular).
       Strip depth = plank LENGTH.  Joint spacing = plank WIDTH.
       Linear scale: 408mm strip is exactly 2x deeper than 204mm (true proportions). */
    var frisThick = Math.max(6,  Math.min(30, Math.round(frisL * 0.0686)));
    var fhSpc     = Math.max(5,  Math.min(20, Math.round(frisW * 0.160)));

    /* LOPBAND: planks run ALONG wall (parallel).
       Strip depth = plank WIDTH.  Joint spacing = plank LENGTH.
       Linear scale: 408mm plank gives exactly 2x wider joints than 204mm. */
    var lopThick  = Math.max(4,  Math.min(14, Math.round(lopW  * 0.140)));
    var lhSpc     = Math.max(10, Math.min(40, Math.round(lopL  * 0.0882)));

    var svg = sec.querySelector("#roomVizSvg");
    if (!svg) return;

    /* Helper: fill a <g> with evenly-spaced joint lines */
    function fillJoints(gId, ax, ay, bx, by, spacing, horiz, color) {
      var g = svg.querySelector("#" + gId);
      if (!g) return;
      while (g.firstChild) g.removeChild(g.firstChild);
      if (!color) return;
      var pos = (horiz ? ax : ay) + spacing;
      var lim = horiz ? bx : by;
      while (pos < lim - 1) {
        var ln = document.createElementNS(NS, "line");
        if (horiz) {
          ln.setAttribute("x1", String(Math.round(pos))); ln.setAttribute("x2", String(Math.round(pos)));
          ln.setAttribute("y1", String(ay));              ln.setAttribute("y2", String(by));
        } else {
          ln.setAttribute("x1", String(ax));              ln.setAttribute("x2", String(bx));
          ln.setAttribute("y1", String(Math.round(pos))); ln.setAttribute("y2", String(Math.round(pos)));
        }
        ln.setAttribute("stroke", color);
        ln.setAttribute("stroke-width", "0.7");
        g.appendChild(ln);
        pos += spacing;
      }
    }

    /* \u2500\u2500 Herringbone center \u2014 shrink rect to inner area \u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
    var frisIn = state.frisEnabled    ? frisThick : 0;
    var lopIn  = state.lopbandEnabled ? lopThick  : 0;
    var inset  = frisIn + lopIn;
    var innerX = FLOOR_X + inset;
    var innerY = FLOOR_Y + inset;
    var innerW = Math.max(0, FLOOR_W - 2 * inset);
    var innerH = Math.max(0, FLOOR_H - 2 * inset);
    /* Anchor pattern origin to inner area so the herringbone tile
       stays visually stable when border thickness changes */
    var hbPat = svg.querySelector("#rvHBPat");
    if (hbPat) {
      hbPat.setAttribute("x", String(innerX));
      hbPat.setAttribute("y", String(innerY));
    }
    var cf = svg.querySelector("#rvCenterFill");
    if (cf) {
      cf.setAttribute("x",      String(innerX));
      cf.setAttribute("y",      String(innerY));
      cf.setAttribute("width",  String(innerW));
      cf.setAttribute("height", String(innerH));
    }

    /* \u2500\u2500 Fris \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
    var fOp    = state.frisEnabled ? "1" : "0";
    var fColor = state.frisEnabled ? "rgba(255,255,255,0.3)" : null;
    /* Corner-safe inner bounds for side strips (exclude overlapping corners) */
    var fInnerY1 = FLOOR_Y + frisThick, fInnerY2 = FLOOR_Y + FLOOR_H - frisThick;

    var ft = svg.querySelector("#rvFrisTop");
    if (ft) { ft.setAttribute("y", String(FLOOR_Y)); ft.setAttribute("height", String(frisThick)); ft.setAttribute("opacity", fOp); }
    fillJoints("rvFrisTJ", FLOOR_X, FLOOR_Y, FLOOR_X + FLOOR_W, FLOOR_Y + frisThick, fhSpc, true, fColor);

    var fb = svg.querySelector("#rvFrisBottom");
    var fbY = FLOOR_Y + FLOOR_H - frisThick;
    if (fb) { fb.setAttribute("y", String(fbY)); fb.setAttribute("height", String(frisThick)); fb.setAttribute("opacity", fOp); }
    fillJoints("rvFrisBJ", FLOOR_X, fbY, FLOOR_X + FLOOR_W, fbY + frisThick, fhSpc, true, fColor);

    var fl = svg.querySelector("#rvFrisLeft");
    if (fl) { fl.setAttribute("x", String(FLOOR_X)); fl.setAttribute("width", String(frisThick)); fl.setAttribute("opacity", fOp); }
    fillJoints("rvFrisLJ", FLOOR_X, fInnerY1, FLOOR_X + frisThick, fInnerY2, fhSpc, false, fColor);

    var fr = svg.querySelector("#rvFrisRight");
    var frX = FLOOR_X + FLOOR_W - frisThick;
    if (fr) { fr.setAttribute("x", String(frX)); fr.setAttribute("width", String(frisThick)); fr.setAttribute("opacity", fOp); }
    fillJoints("rvFrisRJ", frX, fInnerY1, frX + frisThick, fInnerY2, fhSpc, false, fColor);

    /* \u2500\u2500 L\u00f6pband \u2014 rectangular frame just inside the fris \u2500\u2500\u2500\u2500\u2500 */
    var lOp    = state.lopbandEnabled ? "1" : "0";
    var lColor = state.lopbandEnabled ? "rgba(255,255,255,0.25)" : null;
    var fi     = state.frisEnabled ? frisThick : 0;

    /* Top */
    var ltX = FLOOR_X + fi, ltY = FLOOR_Y + fi, ltW = FLOOR_W - 2 * fi;
    var lt = svg.querySelector("#rvLopTop");
    if (lt) { lt.setAttribute("x", String(ltX)); lt.setAttribute("y", String(ltY)); lt.setAttribute("width", String(ltW)); lt.setAttribute("height", String(lopThick)); lt.setAttribute("opacity", lOp); }
    fillJoints("rvLopTJ", ltX, ltY, ltX + ltW, ltY + lopThick, lhSpc, true, lColor);

    /* Bottom */
    var lbX = ltX, lbY = FLOOR_Y + FLOOR_H - fi - lopThick;
    var lb = svg.querySelector("#rvLopBottom");
    if (lb) { lb.setAttribute("x", String(lbX)); lb.setAttribute("y", String(lbY)); lb.setAttribute("width", String(ltW)); lb.setAttribute("height", String(lopThick)); lb.setAttribute("opacity", lOp); }
    fillJoints("rvLopBJ", lbX, lbY, lbX + ltW, lbY + lopThick, lhSpc, true, lColor);

    /* Left \u2014 corner-safe: between top and bottom l\u00f6pband */
    var llX = FLOOR_X + fi, llY = ltY + lopThick, llH = FLOOR_H - 2 * fi - 2 * lopThick;
    var ll = svg.querySelector("#rvLopLeft");
    if (ll) { ll.setAttribute("x", String(llX)); ll.setAttribute("y", String(llY)); ll.setAttribute("width", String(lopThick)); ll.setAttribute("height", String(llH)); ll.setAttribute("opacity", lOp); }
    fillJoints("rvLopLJ", llX, llY, llX + lopThick, llY + llH, lhSpc, false, lColor);

    /* Right */
    var lrX = FLOOR_X + FLOOR_W - fi - lopThick;
    var lr = svg.querySelector("#rvLopRight");
    if (lr) { lr.setAttribute("x", String(lrX)); lr.setAttribute("y", String(llY)); lr.setAttribute("width", String(lopThick)); lr.setAttribute("height", String(llH)); lr.setAttribute("opacity", lOp); }
    fillJoints("rvLopRJ", lrX, llY, lrX + lopThick, llY + llH, lhSpc, false, lColor);

    /* \u2500\u2500 Legend \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
    var legFris = sec.querySelector("#rvLegendFris");
    var legLop  = sec.querySelector("#rvLegendLop");
    if (legFris) legFris.style.display = state.frisEnabled   ? "" : "none";
    if (legLop)  legLop.style.display  = state.lopbandEnabled ? "" : "none";
  }

  /* Find the fris variant by "WWxLL" key, e.g. "68x204" */
  function findVariantBySize(sizeKey) {
    if (!state.selectedType || !sizeKey) return null;
    var parts = String(sizeKey).split("x");
    var targetWidth = parseInt(parts[0], 10) || 68;
    var targetLength = parseInt(parts[1], 10) || 204;
    var allVariants = getVariantsForType(state.selectedType);
    for (var i = 0; i < allVariants.length; i++) {
      var v = allVariants[i];
      if (Number(v.width_mm) === targetWidth && Number(v.length_mm) === targetLength && v.available) {
        return v;
      }
    }
    return null;
  }

  function findFrisVariant() {
    return findVariantBySize(state.frisSize);
  }

  /* \u2500\u2500 Sort selection \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function selectType(type) {
    state.selectedType = type;
    state.selectedVariant = null;
    sortCards.forEach(function (c) {
      var isSel = c.dataset.type === type;
      c.classList.toggle("is-selected", isSel);
      c.setAttribute("aria-checked", isSel ? "true" : "false");
    });
    nextToStep3.disabled = !state.selectedType;
    renderFrisSizes();
    renderLopbandSizes();
    updateSummary();
    renderTierComparison();
    saveState();
  }

  /* \u2500\u2500 Tier price comparison (step 2) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var TIER_LABELS = { rustic: "Rustic", natur: "Natur", select: "Select" };

  function renderTierComparison() {
    var area = state.totalArea;
    var spill = (state.spillPct || 12) / 100;
    var need = area > 0 ? area * (1 + spill) : 0;

    sortCards.forEach(function (card) {
      var type = card.dataset.type;
      if (!type) return;

      /* Apply flex-column so all cards share equal height with footer pinned */
      card.classList.add("sortCard--visual");

      /* Get or create the price row inside this card */
      var row = card.querySelector(".sortCard__priceRow");
      if (!row) {
        row = document.createElement("div");
        row.className = "sortCard__priceRow";
        card.appendChild(row);
      }

      var variants = getVariantsForType(type).filter(function (v) {
        return v.available && v.price_cents > 0 && v.m2_per_pack > 0;
      });

      var badgeEl = type === "select"
        ? '<div class="sortCard__badge">\u2605 B\u00e4sts\u00e4ljare</div>'
        : '<div class="sortCard__badge--ghost"></div>';

      if (!variants.length) {
        row.innerHTML = badgeEl + '<span class="sortCard__total">\u2014</span>';
        return;
      }

      var minPPM2 = Math.min.apply(null, variants.map(function (v) { return Math.round(v.price_cents / v.m2_per_pack); }));
      /* Always show entry price per m\u00b2 \u2014 clean "fr\u00e5n X kr/m\u00b2" */
      var ppm2Label = "fr\u00e5n " + Math.round(minPPM2 / 100) + " kr/m\u00b2";

      /* No area entered yet \u2014 show price per m\u00b2 so tiers are still comparable */
      if (!need) {
        row.innerHTML =
          badgeEl +
          '<span class="sortCard__total">' + ppm2Label + '</span>' +
          '<div class="sortCard__ppm2">Ange yta f\u00f6r totalpris</div>';
        return;
      }

      var cheapV = variants.reduce(function (a, b) {
        return (a.price_cents / a.m2_per_pack) <= (b.price_cents / b.m2_per_pack) ? a : b;
      });
      var packs = Math.ceil(need / cheapV.m2_per_pack);
      var totalCents = packs * cheapV.price_cents;

      row.innerHTML =
        badgeEl +
        '<span class="sortCard__total">' + fmtMoney(totalCents) + '</span>' +
        '<div class="sortCard__ppm2">' + ppm2Label + ' \u00b7 inkl. spill</div>';
    });
  }

  /* \u2500\u2500 Size rendering \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function renderSizes() {
    sizesAll.innerHTML = "";
    var listAll = getVariantsForType(state.selectedType || "rustic")
      .filter(function (v) { return v.available; })
      .filter(function (v) { return Number(v.variant_id); })
      .filter(function (v) {
        return Number(v.width_mm) > 0 && Number(v.length_mm) > 0;
      })
      .sort(function (a, b) {
        var aw = Number(a.width_mm || 0),
          bw = Number(b.width_mm || 0);
        if (aw !== bw) return bw - aw;
        return Number(a.length_mm || 0) - Number(b.length_mm || 0);
      });

    if (!listAll.length) {
      sizesAll.innerHTML =
        '<div style="opacity:.75; padding:.2rem 0;">' +
        "Inga storlekar hittades." +
        '<div style="margin-top:.4rem; font-size:12px; opacity:.8;">' +
        'Kontrollera att varianterna har metafields: width_mm, length_mm, enhetspris (m\u00b2 per paket) \u2014 eller att variant-titeln inneh\u00e5ller t.ex. "68\u00d7204".' +
        "</div></div>";
      return;
    }

    var groups = new Map();
    listAll.forEach(function (v) {
      var w = String(Number(v.width_mm || 0));
      if (!groups.has(w)) groups.set(w, []);
      groups.get(w).push(v);
    });

    var widths = listAll
      .map(function (v) { return Number(v.width_mm || 0); })
      .filter(Boolean);
    var lengths = listAll
      .map(function (v) { return Number(v.length_mm || 0); })
      .filter(Boolean);
    var maxW = widths.length ? Math.max.apply(null, widths) : 0;
    var maxL = lengths.length ? Math.max.apply(null, lengths) : 0;
    var MAX_H = 165, MIN_H = 55, MAX_W = 66, MIN_W = 20;

    function mapLinear(val, maxVal, minPx, maxPx) {
      if (!val || !maxVal) return minPx;
      var t = val / maxVal;
      return minPx + (maxPx - minPx) * t;
    }

    function makeBtn(v) {
      var w = Number(v.width_mm || 0),
        L = Number(v.length_mm || 0),
        plankW = mapLinear(w, maxW, MIN_W, MAX_W),
        plankH = mapLinear(L, maxL, MIN_H, MAX_H);
      /* 1. Price per m\u00b2 label */
      var packPrice = Number(v.price_cents || 0);
      var m2pp = Number(v.m2_per_pack || 0);
      var pricePerM2Kr = (packPrice > 0 && m2pp > 0)
        ? Math.round(packPrice / m2pp / 100) : 0;

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "nw-plankbtn";
      btn.setAttribute("role", "radio");
      btn.setAttribute("aria-checked", "false");
      btn.tabIndex = -1;
      btn.dataset.id = String(v.variant_id);
      btn.innerHTML =
        '<div class="nw-plank" style="--plank-w:' +
        plankW.toFixed(0) +
        "px; --plank-h:" +
        plankH.toFixed(0) +
        'px" aria-hidden="true"><span>' +
        w +
        " \u00d7 " +
        L +
        "</span></div>" +
        (pricePerM2Kr ? '<span class="nw-plank-price">' + pricePerM2Kr + ' kr/m\u00b2</span>' : '');

      btn.addEventListener("click", function () {
        state.selectedVariant = v;
        /* Auto-match fris & l\u00f6pband size to the selected floor plank */
        var autoKey = v.width_mm + "x" + v.length_mm;
        state.frisSize = autoKey;
        state.lopbandSize = autoKey;
        renderFrisSizes();
        renderAccessorySizes("lopbandSizes", state.lopbandSize, function (key) { state.lopbandSize = key; });
        sizesAll.querySelectorAll(".nw-plankbtn").forEach(function (x) {
          x.classList.remove("is-active");
          x.setAttribute("aria-checked", "false");
          x.tabIndex = -1;
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-checked", "true");
        btn.tabIndex = 0;
        /* Hide "choose a size" prompt once user picks */
        var hint = root.querySelector("#kalk-size-hint");
        if (hint) hint.classList.add("is-hidden");
        updateSummary();
        saveState();
        btn.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      });
      return btn;
    }

    /* Hint sits ABOVE #sizesAll (as a sibling) so it doesn't become a flex item in the mobile swipe row */
    var oldHint = root.querySelector("#kalk-size-hint");
    if (oldHint) oldHint.parentNode.removeChild(oldHint);
    var sizeHint = document.createElement("p");
    sizeHint.id = "kalk-size-hint";
    sizeHint.className = "kalk-size-hint" + (state.selectedVariant ? " is-hidden" : "");
    sizeHint.textContent = "V\u00e4lj en storlek nedan f\u00f6r att se exakt pris och antal paket";
    sizesAll.insertAdjacentElement("beforebegin", sizeHint);

    /* Render groups inside a swipe wrapper so mobile can scroll horizontally
       without fighting the theme's overflow on parent containers */
    var swipeRow = document.createElement("div");
    swipeRow.className = "nw-swipe-row";

    var isFirstGroup = true;
    groups.forEach(function (items, w) {
      var group = document.createElement("div");
      group.className = "nw-group";
      var label = document.createElement("div");
      label.className = "nw-group-label";
      if (isFirstGroup) {
        label.innerHTML = w + ' mm <span class="kalk-pop-tag">\u2605 Popul\u00e4rast</span>';
        isFirstGroup = false;
      } else {
        label.textContent = w + " mm";
      }
      group.appendChild(label);
      var bars = document.createElement("div");
      bars.className = "nw-group-bars";
      items.forEach(function (v) {
        bars.appendChild(makeBtn(v));
      });
      group.appendChild(bars);
      swipeRow.appendChild(group);
    });

    sizesAll.appendChild(swipeRow);
  }

  /* \u2500\u2500 Calculation \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function calc() {
    var mainArea = state.totalArea;
    var frisArea = state.frisEnabled ? state.totalPerimeter * (getFrisDepthMM() / 1000) : 0;
    var totalArea = mainArea + frisArea;
    var spill = state.spillPct / 100;
    var v = state.selectedVariant;

    if (!v || !mainArea || mainArea <= 0) return null;

    var m2pp = Number(v.m2_per_pack || 0);
    if (!m2pp || m2pp <= 0) return null;

    /* Main floor */
    var mainNeed = mainArea * (1 + spill);
    var mainPacks = Math.ceil(mainNeed / m2pp);
    var mainDelivered = mainPacks * m2pp;
    var mainTotal = mainPacks * Number(v.price_cents || 0);

    /* Fris (border strip) \u2014 separate variant & packs */
    var frisPacks = 0, frisDelivered = 0, frisTotal = 0, frisVariantObj = null;
    if (state.frisEnabled && frisArea > 0) {
      frisVariantObj = findFrisVariant();
      if (frisVariantObj) {
        var frisNeed = frisArea * (1 + spill);
        var frisM2pp = Number(frisVariantObj.m2_per_pack || 0);
        if (frisM2pp > 0) {
          frisPacks = Math.ceil(frisNeed / frisM2pp);
          frisDelivered = frisPacks * frisM2pp;
          frisTotal = frisPacks * Number(frisVariantObj.price_cents || 0);
        }
      }
    }

    /* L\u00f6pband (decorative running band) */
    var lopbandPacks = 0, lopbandDelivered = 0, lopbandTotal = 0, lopbandVariantObj = null;
    var lopbandNeedCalc = 0; /* declared here so r.need can reference it cleanly */
    if (state.lopbandEnabled && state.totalPerimeter > 0) {
      lopbandVariantObj = findVariantBySize(state.lopbandSize);
      if (lopbandVariantObj) {
        var lopW = parseInt(String(state.lopbandSize || "68x204").split("x")[0], 10) || 68;
        var lopbandArea = state.totalPerimeter * (lopW / 1000);
        lopbandNeedCalc = lopbandArea * (1 + spill);
        var lopbandM2pp = Number(lopbandVariantObj.m2_per_pack || 0);
        if (lopbandM2pp > 0) {
          lopbandPacks = Math.ceil(lopbandNeedCalc / lopbandM2pp);
          lopbandDelivered = lopbandPacks * lopbandM2pp;
          lopbandTotal = lopbandPacks * Number(lopbandVariantObj.price_cents || 0);
        }
      }
    }

    return {
      mainArea: mainArea,
      frisArea: frisArea,
      totalArea: totalArea,
      mainNeed: mainNeed,
      mainPacks: mainPacks,
      mainDelivered: mainDelivered,
      mainTotal: mainTotal,
      frisPacks: frisPacks,
      frisDelivered: frisDelivered,
      frisTotal: frisTotal,
      frisVariant: frisVariantObj,
      lopbandPacks: lopbandPacks,
      lopbandDelivered: lopbandDelivered,
      lopbandTotal: lopbandTotal,
      lopbandVariant: lopbandVariantObj,
      need: mainNeed + (frisArea > 0 ? frisArea * (1 + spill) : 0) + lopbandNeedCalc,
      packs: mainPacks + frisPacks + lopbandPacks,
      delivered: mainDelivered + frisDelivered + lopbandDelivered,
      total: mainTotal + frisTotal + lopbandTotal
    };
  }

  /* \u2500\u2500 7. Fris price compare element \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var sumFrisCompareEl = null;

  function createFrisCompare() {
    if (!sumTotal) return;
    var existing = root.querySelector("#sumFrisCompare");
    if (existing) { sumFrisCompareEl = existing; return; }
    var el = document.createElement("div");
    el.id = "sumFrisCompare";
    /* Insert after the row that contains sumTotal */
    var totalRow = sumTotal.parentElement;
    if (totalRow && totalRow.parentElement) {
      totalRow.parentElement.insertBefore(el, totalRow.nextSibling);
    } else if (totalRow) {
      totalRow.appendChild(el);
    }
    sumFrisCompareEl = el;
  }

  function updateFrisCompare(r) {
    if (!sumFrisCompareEl) return;
    var hasFris = r && r.frisPacks > 0;
    var hasLop = r && r.lopbandPacks > 0;
    if (hasFris || hasLop) {
      var parts = ["Golv: " + fmtMoney(r.mainTotal)];
      if (hasFris) parts.push("Fris: " + fmtMoney(r.frisTotal));
      if (hasLop) parts.push("L\u00f6pband: " + fmtMoney(r.lopbandTotal));
      sumFrisCompareEl.textContent = parts.join(" + ");
      sumFrisCompareEl.classList.add("is-visible");
    } else {
      sumFrisCompareEl.classList.remove("is-visible");
    }
  }

  /* \u2500\u2500 10. Sticky result card (desktop) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var stickyResultDone = false;
  function setupStickyResult() {
    if (stickyResultDone) return;
    if (window.innerWidth < 900) return;
    var card = root.querySelector(".kcard--right");
    if (!card) return;
    stickyResultDone = true;
    card.style.position = "sticky";
    card.style.alignSelf = "start";
    card.style.top = "110px";
  }

  /* \u2500\u2500 11. Right card extras (Klarna, provbit, advisor) \u2500\u2500\u2500 */
  var rightExtrasDone = false;
  var klarnaEl = null;

  function setupRightCardExtras() {
    if (rightExtrasDone) return;
    var anchor = root.querySelector("#checkoutBtn");
    if (!anchor) return;
    rightExtrasDone = true;

    /* Klarna On-Site Messaging */
    var kl = document.createElement("klarna-placement");
    kl.setAttribute("data-key", "credit-promotion-auto-size");
    kl.setAttribute("data-locale", "sv-SE");
    kl.setAttribute("data-purchase-amount", "0");
    kl.className = "kalk-klarna";
    klarnaEl = kl;
    anchor.insertAdjacentElement("afterend", kl);

    /* Provbit CTA */
    var pBtn = document.createElement("a");
    pBtn.href = "/products/provbitar-akta-tragolv-3-st";
    pBtn.className = "kalk-provbit-btn";
    pBtn.textContent = "Best\u00e4ll provbitar";
    kl.insertAdjacentElement("afterend", pBtn);

    /* Advisor CTA */
    var adv = document.createElement("a");
    adv.href = "/pages/contact";
    adv.className = "kalk-advisor-cta";
    adv.textContent = "Os\u00e4ker p\u00e5 vilket golv? F\u00e5 svar inom 24h \u2192";
    pBtn.insertAdjacentElement("afterend", adv);
  }

  /* \u2500\u2500 12. Mobile sticky bar \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var mbarEl = null, mbarTotalEl = null, mbarBtnEl = null, mbarPacksEl = null;

  function createMobileBar() {
    if (mbarEl) return;
    var bar = document.createElement("div");
    bar.className = "kalk-mbar";
    bar.setAttribute("aria-hidden", "true");
    bar.innerHTML =
      '<div class="kalk-mbar__info">' +
      '<div class="kalk-mbar__label">F\u00f6rhandsresultat</div>' +
      '<div class="kalk-mbar__total" id="mbarTotal">\u2014</div>' +
      '</div>' +
      '<div class="kalk-mbar__packs" id="mbarPacks"></div>' +
      '<button type="button" class="kalk-mbar__btn" id="mbarBtn" disabled>L\u00e4gg i varukorg</button>';
    document.body.appendChild(bar);
    mbarEl = bar;
    mbarTotalEl = bar.querySelector("#mbarTotal");
    mbarPacksEl = bar.querySelector("#mbarPacks");
    mbarBtnEl = bar.querySelector("#mbarBtn");

    /* Delegate to the main add-to-cart button */
    mbarBtnEl.addEventListener("click", function () {
      if (addToCartBtn && !addToCartBtn.disabled) addToCartBtn.click();
    });

    /* Hide bar when the result/summary card is visible in viewport */
    var resultCard = root.querySelector(".kcard--result") ||
      root.querySelector(".kcard--summary") ||
      root.querySelector("#kalk-step3");
    if (resultCard && typeof IntersectionObserver !== "undefined") {
      var obs = new IntersectionObserver(function (entries) {
        /* Hide bar whenever the result card is visible on screen */
        mbarEl.classList.toggle("result-shown", entries[0].isIntersecting);
      }, { threshold: 0.15 });
      obs.observe(resultCard);
    }
  }

  function updateMobileBar(r) {
    if (!mbarEl) return;
    var hasTotal = !!(r && r.total > 0);
    mbarEl.classList.toggle("is-visible", hasTotal);
    if (hasTotal) {
      mbarTotalEl.textContent = fmtMoney(r.total);
      if (mbarPacksEl) mbarPacksEl.textContent = r.packs + " paket";
      mbarBtnEl.disabled = false;
    } else {
      mbarTotalEl.textContent = "\u2014";
      if (mbarPacksEl) mbarPacksEl.textContent = "";
      mbarBtnEl.disabled = true;
    }
  }

  /* \u2500\u2500 Summary update \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function updateSummary() {
    var spill = state.spillPct / 100;
    var mainArea = state.totalArea;
    var frisArea = state.frisEnabled ? state.totalPerimeter * (getFrisDepthMM() / 1000) : 0;
    var totalArea = mainArea + frisArea;

    /* Fris summary rows visibility */
    if (sumFrisRow) {
      sumFrisRow.classList.toggle("is-visible", state.frisEnabled);
    }
    if (sumTotalAreaRow) {
      sumTotalAreaRow.classList.toggle("is-visible", state.frisEnabled);
    }

    /* Floor area row (always show if we have area) */
    if (sumFloorArea) {
      sumFloorArea.textContent = mainArea > 0 ? fmt2(mainArea) + " m\u00b2" : "\u2014";
    }

    /* Fris row */
    if (sumFrisLabel && state.frisEnabled) {
      sumFrisLabel.textContent = "Fris (" + fmt2(state.totalPerimeter) + " l\u00f6pmeter)";
    }
    if (sumFrisArea && state.frisEnabled) {
      sumFrisArea.textContent = fmt2(frisArea) + " m\u00b2";
    }

    /* Combined area row */
    if (sumCombinedArea && state.frisEnabled) {
      sumCombinedArea.textContent = fmt2(totalArea) + " m\u00b2";
    }

    var colTitle =
      (data.collections[state.selectedType] &&
        data.collections[state.selectedType].title) ||
      "\u2014";

    if (!state.selectedVariant) {
      var tierNames = { select: "Select", natur: "Natur", rustic: "Rustic" };
      sumProduct.textContent = state.selectedType ? (tierNames[state.selectedType] || "\u2014") : "\u2014";
      sumSize.textContent = state.selectedType ? "V\u00e4lj storlek \u2192" : "\u2014";
      sumPrice.textContent = "\u2014";
      sumM2PerPack.textContent = "\u2014";
      sumNeed.textContent = totalArea > 0 ? fmt2(totalArea * (1 + spill)) + " m\u00b2" : "\u2014";
      sumPacks.textContent = "\u2014";
      sumDelivered.textContent = "\u2014";
      /* Show rough estimate when type + area are known */
      if (state.selectedType && totalArea > 0) {
        var estVars = getVariantsForType(state.selectedType).filter(function (ev) {
          return ev.available && ev.price_cents > 0 && ev.m2_per_pack > 0;
        });
        if (estVars.length) {
          var estNeed = totalArea * (1 + spill);
          var estCheap = estVars.reduce(function (a, b) {
            return (a.price_cents / a.m2_per_pack) <= (b.price_cents / b.m2_per_pack) ? a : b;
          });
          var estPacks = Math.ceil(estNeed / estCheap.m2_per_pack);
          sumTotal.textContent = "ca " + fmtMoney(estPacks * estCheap.price_cents);
        } else {
          sumTotal.textContent = "\u2014";
        }
      } else {
        sumTotal.textContent = "\u2014";
      }
      addToCartBtn.disabled = true;
      updateFrisCompare(null);
      updateMobileBar(null);
      updateRoomVisualizer();
      return;
    }

    var v = state.selectedVariant,
      t = Number(v.thickness_mm || 0) || 16,
      w = Number(v.width_mm || 0),
      L = Number(v.length_mm || 0),
      packPrice = Number(v.price_cents || 0),
      m2pp = Number(v.m2_per_pack || 0),
      pricePerM2 =
        packPrice > 0 && m2pp > 0 ? Math.round(packPrice / m2pp) : 0;

    sumProduct.textContent = v.product_title || colTitle;
    sumSize.textContent = t + " \u00d7 " + w + " \u00d7 " + L + " mm";
    sumPrice.textContent = pricePerM2 ? fmtMoneyPerM2(pricePerM2) : "\u2014";
    sumM2PerPack.textContent = m2pp ? fmt2(m2pp) + " m\u00b2" : "\u2014";

    var r = calc();
    if (!r) {
      sumNeed.textContent =
        totalArea > 0
          ? fmt2(totalArea * (1 + spill)) + " m\u00b2"
          : "\u2014";
      sumPacks.textContent = "\u2014";
      sumDelivered.textContent = "\u2014";
      sumTotal.textContent = "\u2014";
      addToCartBtn.disabled = true;
      updateFrisCompare(null);
      updateMobileBar(null);
      updateRoomVisualizer();
      return;
    }

    sumNeed.textContent = fmt2(r.need) + " m\u00b2";
    var packsStr = String(r.mainPacks);
    if (r.frisPacks > 0) packsStr += " + " + r.frisPacks + " (fris)";
    if (r.lopbandPacks > 0) packsStr += " + " + r.lopbandPacks + " (l\u00f6pband)";
    sumPacks.textContent = packsStr;
    sumDelivered.textContent = fmt2(r.delivered) + " m\u00b2";
    sumTotal.textContent = fmtMoney(r.total);
    addToCartBtn.disabled = false;
    updateFrisCompare(r);
    updateMobileBar(r);
    updateRoomVisualizer();
    if (klarnaEl) {
      klarnaEl.setAttribute("data-purchase-amount", String(r.total));
      if (window.Klarna && window.Klarna.OnsiteMessaging) {
        window.Klarna.OnsiteMessaging.refresh();
      }
    }
  }

  /* \u2500\u2500 Cart functions \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  async function fetchCart() {
    try {
      var res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) throw new Error("Cart fetch failed: " + res.status);
      return await res.json();
    } catch (e) {
      console.error("[Kalkylator] fetchCart:", e.message);
      return { items: [], items_subtotal_price: 0 };
    }
  }

  async function addToCart(items) {
    try {
      var res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) throw new Error("Add to cart failed: " + res.status);
    } catch (e) {
      console.error("[Kalkylator] addToCart:", e.message);
      var _btn = document.getElementById("addToCartBtn");
      if (_btn && _btn.parentNode) {
        var _err = document.getElementById("nwCartError");
        if (!_err) {
          _err = document.createElement("p");
          _err.id = "nwCartError";
          _err.setAttribute("role", "alert");
          _err.style.cssText = "color:#b00020;font-size:13px;margin:8px 0 0;text-align:center;";
          _btn.parentNode.appendChild(_err);
        }
        _err.textContent = "Kunde inte l\u00e4gga till i varukorgen. F\u00f6rs\u00f6k igen.";
      }
    }
  }

  async function changeLine(line, qty) {
    try {
      var res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ line: line, quantity: qty })
      });
      if (!res.ok) throw new Error("Cart update failed: " + res.status);
    } catch (e) {
      console.error("[Kalkylator] changeLine:", e.message);
    }
  }

  async function renderCart() {
    var cart = await fetchCart();
    cartItems.innerHTML = "";
    if (!cart.items || cart.items.length === 0) {
      cartItems.innerHTML =
        '<div style="opacity:.7; padding:10px 0;">Varukorgen \u00e4r tom.</div>';
      cartSubtotal.textContent = "0 kr";
      return;
    }
    cart.items.forEach(function (it, idx) {
      var line = idx + 1;
      var img = it.image
        ? it.image.replace(/(\.[a-z]+)$/, "_160x$1")
        : null;
      var row = document.createElement("div");
      row.className = "cartItem";
      row.innerHTML =
        '<div class="cartItem__img">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") +
        "</div>" +
        "<div>" +
        '<div class="cartItem__title">' +
        escapeHtml(it.product_title || it.title) +
        "</div>" +
        '<div class="cartItem__meta">' +
        escapeHtml(
          (it.variant_title || "").replace("Default Title", "").trim()
        ) +
        "</div>" +
        (it.properties && Object.keys(it.properties).filter(function(k){ return it.properties[k] && k.charAt(0) !== "_"; }).length > 0
          ? '<div class="cartItem__props">' +
            Object.keys(it.properties).filter(function(k){ return it.properties[k] && k.charAt(0) !== "_"; }).map(function(k){
              return '<span>' + escapeHtml(k) + ': ' + escapeHtml(String(it.properties[k])) + '</span>';
            }).join("") +
            "</div>"
          : "") +
        "</div>" +
        '<input class="qty" type="number" min="0" value="' +
        it.quantity +
        '" data-line="' +
        line +
        '" aria-label="Antal" />' +
        '<div class="cartItem__price">' +
        fmtMoney(it.final_line_price) +
        "</div>" +
        '<button class="iconBtn" type="button" data-remove="' +
        line +
        '" aria-label="Ta bort">\u00d7</button>';
      cartItems.appendChild(row);
    });
    cartSubtotal.textContent = fmtMoney(cart.items_subtotal_price);

    cartItems.querySelectorAll(".qty").forEach(function (inp) {
      inp.addEventListener("change", async function () {
        var ln = Number(inp.dataset.line);
        var qty = Math.max(0, parseInt(inp.value, 10) || 0);
        await changeLine(ln, qty);
        await renderCart();
      });
    });
    cartItems.querySelectorAll("[data-remove]").forEach(function (btn) {
      btn.addEventListener("click", async function () {
        var ln = Number(btn.dataset.remove);
        await changeLine(ln, 0);
        await renderCart();
      });
    });
  }

  /* \u2500\u2500 Spill persistence \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function loadSpill() {
    try {
      var saved = sessionStorage.getItem("kalkylator_spill_pct");
      var pct = saved ? parseInt(saved, 10) : 12;
      state.spillPct = isNaN(pct) ? 12 : pct;
    } catch (e) {
      state.spillPct = 12;
    }
  }

  function saveSpill() {
    try {
      sessionStorage.setItem("kalkylator_spill_pct", String(state.spillPct));
    } catch (e) {
      /* noop */
    }
  }

  /* \u2500\u2500 Event wiring \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  stepTabs.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var s = Number(btn.dataset.step);
      if (!btn.disabled) setStep(s);
    });
  });

  /* 5. Smart room names */
  addRoomBtn.addEventListener("click", function () {
    var suggestedNames = ["Vardagsrum", "Sovrum", "K\u00f6k", "Hall", "Kontor", "Matsal", "G\u00e4strum"];
    var existingNames = state.rooms.map(function (r) { return r.name; });
    var nextName = null;
    for (var i = 0; i < suggestedNames.length; i++) {
      if (existingNames.indexOf(suggestedNames[i]) === -1) {
        nextName = suggestedNames[i];
        break;
      }
    }
    if (!nextName) nextName = "Rum " + (state.rooms.length + 1);
    state.rooms.push({ name: nextName, length: "", width: "" });
    renderRooms();
    saveState();
  });

  clearRoomsBtn.addEventListener("click", function () {
    state.rooms = [{ name: "Rum 1", length: "", width: "" }];
    renderRooms();
    recalcTotalArea();
  });

  nextToStep2.addEventListener("click", function () {
    setStep(2);
  });
  backToStep1.addEventListener("click", function () {
    setStep(1);
  });
  nextToStep3.addEventListener("click", function () {
    setStep(3);
  });
  backToStep2.addEventListener("click", function () {
    setStep(2);
  });

  /* 4. KLAR button visual feedback */
  doneBtn.addEventListener("click", function () {
    var orig = doneBtn.textContent;
    doneBtn.textContent = "\u2713 " + orig;
    doneBtn.classList.add("klarBtn--done");
    saveState();
    setTimeout(function () {
      doneBtn.textContent = orig;
      doneBtn.classList.remove("klarBtn--done");
    }, 1600);
    var cartCard = root.querySelector(".kcard--cart");
    if (cartCard) cartCard.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  sortCards.forEach(function (btn) {
    btn.addEventListener("click", function () {
      selectType(btn.dataset.type);
    });
  });

  spillSelect.addEventListener("change", function () {
    state.spillPct = parseInt(spillSelect.value, 10) || 0;
    saveSpill();
    updateSummary();
    saveState();
  });

  refreshCartBtn.addEventListener("click", async function () {
    await renderCart();
  });

  addToCartBtn.addEventListener("click", async function () {
    var r = calc();
    if (!r || !state.selectedVariant) return;
    addToCartBtn.disabled = true;
    var originalText = addToCartBtn.textContent;
    addToCartBtn.textContent = "L\u00e4gger till\u2026";
    var items = [{ id: state.selectedVariant.variant_id, quantity: r.mainPacks }];
    if (r.frisPacks > 0) {
      var fv = r.frisVariant;
      if (fv && fv.variant_id !== state.selectedVariant.variant_id) {
        items.push({ id: fv.variant_id, quantity: r.frisPacks,
          properties: { "\u00c4ndam\u00e5l": "Fris (kantlist)" } });
      } else {
        items[0].quantity = r.mainPacks + r.frisPacks;
        items[0].properties = { "Varav fris (kantlist)": r.frisPacks + " paket" };
      }
    }
    if (r.lopbandPacks > 0) {
      var lv = r.lopbandVariant;
      if (lv && lv.variant_id !== state.selectedVariant.variant_id) {
        items.push({ id: lv.variant_id, quantity: r.lopbandPacks,
          properties: { "\u00c4ndam\u00e5l": "L\u00f6pband (" + fmt2(state.totalPerimeter) + " lm)" } });
      } else {
        /* Same variant as floor \u2014 add packs with note */
        items[0].quantity = (items[0].quantity || r.mainPacks) + r.lopbandPacks;
        var existing = items[0].properties || {};
        existing["Varav l\u00f6pband"] = r.lopbandPacks + " paket (" + fmt2(state.totalPerimeter) + " lm)";
        items[0].properties = existing;
      }
    }
    await addToCart(items);
    /* \u2500\u2500 GA4 + Google Ads conversion event \u2500\u2500 */
    try {
      if (typeof gtag === "function" && r.total > 0) {
        var v = state.selectedVariant;
        gtag("event", "add_to_cart", {
          currency: "SEK",
          value: r.total / 100,
          items: [{ item_id: String(v.variant_id), item_name: v.product_title, item_category: state.selectedType, price: v.price_cents / 100, quantity: r.packs }]
        });
        gtag("event", "conversion", { send_to: "AW-17264190604", value: r.total / 100, currency: "SEK" });
      }
    } catch (e) { /* noop */ }
    await renderCart();
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = originalText;
    var nwOpened = false;
    try {
      var secRes = await fetch("/?sections=cart-drawer,cart-icon-bubble");
      if (secRes.ok) {
        var nwSections = await secRes.json();
        var nwDrw = document.querySelector("cart-drawer");
        if (nwDrw && typeof nwDrw.renderContents === "function") {
          nwDrw.classList.remove("is-empty");
          nwDrw.renderContents({ sections: nwSections });
          requestAnimationFrame(function(){ nwDrw.classList.remove("is-empty"); });
          nwOpened = true;
        }
      }
    } catch (e) { /* noop */ }
    if (!nwOpened) {
      var cartCard = root.querySelector(".kcard--cart");
      if (cartCard) cartCard.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  /* \u2500\u2500 Init \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function init() {
    injectStyles();
    loadSpill();
    loadState();
    spillSelect.value = String(state.spillPct);
    renderRooms();
    wireRoomInputs();
    wireFris();
    recalcTotalArea();
    createFrisCompare();
    createLopbandSection();
    wireLopband();
    createRoomVisualizer();
    addFrisHint();
    createMobileBar();

    var targetStep = state.__savedStep || 1;
    if (targetStep > 1 && !(state.totalArea > 0)) targetStep = 1;
    if (targetStep > 2 && !state.selectedType) targetStep = 2;
    setStep(targetStep);

    /* Restore selected variant after sizes are rendered */
    if (targetStep === 3 && state.__savedVariantId) {
      var savedId = state.__savedVariantId;
      setTimeout(function () {
        var btn = sizesAll.querySelector('[data-id="' + savedId + '"]');
        if (btn) btn.click();
      }, 0);
    }

    /* Allow saves from this point on */
    initialized = true;
    if (!state.__savedVariantId) saveState();

    renderCart().catch(function (e) {
      console.error("[Kalkylator] init renderCart:", e.message);
    });
  }

  init();
})();